import { Trigger, TriggerBody } from "types/type.module";
import { Direction } from "types/types";

/*
  @function writeTrigger
  write trigger in condition
  @param directions {array} - direction to write trigger
  @param step {string} - step to write
  @param condition {object} - condition to write
*/
export function writeTrigger(
  directions: any[],
  step: string,
  trigger: any
): any {
  const [currentDirection, ...restDirections] = directions;

  const triggerForCurrentDirection = trigger[currentDirection.op];

  if (!triggerForCurrentDirection) {
    return [{ or: { key: step } }];
  }

  if (restDirections.length === 0) {
    return [...triggerForCurrentDirection, { key: step }];
  }

  return writeTrigger(
    directions,
    step,
    trigger[currentDirection.op][currentDirection.pos]
  );
}

/*
  @function writeOperator
  write operator in condition
  @param directions {array} - direction to write trigger
  @param operator {string} - step to write
  @param condition {object} - condition to write
  @param trigger {string} - trigger to add
  @param depth {number} - depth of recursion
*/
export function writeOperatorAndTrigger(
  directions: any[],
  operator: string,
  condition: any,
  trigger: any,
  depth: number
) {
  const currentDirection = directions.shift();
  const invertedOperator = operator === "and" ? "or" : "and";

  if (currentDirection === undefined) {
    const oldCondition = { ...condition } as const;

    condition[operator] = [
      oldCondition,
      { [invertedOperator]: [{ [operator]: [{ ...trigger }] }] },
    ];

    const opositeOperator = operator === "or" ? "and" : "or";

    delete condition[opositeOperator];
  } else if (directions.length === 0) {
    condition[currentDirection.op].push(
      depth < 1
        ? {
            [operator]: [{ [invertedOperator]: [{ ...trigger }] }],
          }
        : depth < 2
        ? { [operator]: [{ ...trigger }] }
        : { ...trigger }
    );
  } else {
    writeOperatorAndTrigger(
      directions,
      operator,
      condition[currentDirection.op][currentDirection.pos],
      trigger,
      depth + 1
    );
  }
}

/*


*/

/*
  @function toggleTrigger
  negate and un-negate trigger 
  @param directions {array} - direction to toggle trigger
  @param condition {object} - condition to write
*/
export function toggleTrigger(directions: any[], condition: any) {
  const currentDirection = directions.shift();

  if (directions.length === 0) {
    if ("negated" in condition[currentDirection.op][currentDirection.pos]) {
      condition[currentDirection.op][currentDirection.pos].negated = !condition[
        currentDirection.op
      ][currentDirection.pos].negated;
    } else {
      condition[currentDirection.op][currentDirection.pos].negated = true;
    }
  } else {
    toggleTrigger(
      directions,
      condition[currentDirection.op][currentDirection.pos]
    );
  }
}

/*
  @function removeTrigger
  remove trigger at position
  @param directions {array} - direction to toggle trigger
  @param condition {object} - condition to write
*/
export function removeTrigger(directions: Direction[], condition: any) {
  // use spread operator to reassign to make it writable
  directions = [...directions]
  if (directions.length === 0) return;
  const currentDirection = directions.shift();

  if (!currentDirection) return;

  if (directions.length === 0) {
    condition[currentDirection.op].splice(currentDirection.pos, 1);
  } else if (currentDirection) {
    removeTrigger(
      directions,
      condition[currentDirection.op][currentDirection.pos]
    );
  }
}
